import { useOrientation } from '@/hooks/useOrientation';
import styles from './styles.module.scss';
import clsx from 'clsx';
import CategoryTypeSearchControl from '@/components/feature/category-type/category-type-search/category-type-search-control';
import { useCallback } from 'react';
import { CATEGORY_TYPE_SEARCH_MODE } from '@/enums/category-type';
import CategoryTypeSearchByText from '@/components/feature/category-type/category-type-search/category-type-search-by-text';
import CategoryTypeSearchByFloor from '@/components/feature/category-type/category-type-search/category-type-search-by-floor';
import CategoryTypeSearchByCategory from '@/components/feature/category-type/category-type-search/category-type-search-by-category';
import { useCategoryTypeStore } from '@/stores';

interface CategoryTypeSearchProps {
    isVerticalFullscreen?: boolean;
    menuId?: string;
}

const CategoryTypeSearch = ({ isVerticalFullscreen = false, menuId }: CategoryTypeSearchProps) => {
    const { isHorizontal } = useOrientation();
    const currentMode = useCategoryTypeStore((state) => state.currentMode);

    const renderContent = useCallback(() => {
        switch (currentMode) {
            case CATEGORY_TYPE_SEARCH_MODE.SEARCH_BY_TEXT:
                return <CategoryTypeSearchByText isVerticalFullscreen={isVerticalFullscreen} />;
            case CATEGORY_TYPE_SEARCH_MODE.SEARCH_BY_FLOOR:
                return <CategoryTypeSearchByFloor />;
            case CATEGORY_TYPE_SEARCH_MODE.SEARCH_BY_CATEGORY:
                return <CategoryTypeSearchByCategory menuId={menuId} />;
            default:
                return <CategoryTypeSearchByText isVerticalFullscreen={isVerticalFullscreen} />;
        }
    }, [currentMode, isVerticalFullscreen, menuId]);

    return (
        <div
            className={clsx(styles['category-type-search'], {
                [styles['category-type-search__horizontal']]: isHorizontal,
                [styles['category-type-search__vertical']]: !isHorizontal,
                [styles['category-type-search__vertical-fullscreen']]: isVerticalFullscreen,
            })}
        >
            <div
                className={clsx(styles['category-type-search__control'], {
                    [styles['category-type-search__control__horizontal']]: isHorizontal,
                    [styles['category-type-search__control__vertical']]: !isHorizontal && !isVerticalFullscreen,
                    [styles['category-type-search__control__vertical-fullscreen']]: isVerticalFullscreen,
                })}
            >
                <CategoryTypeSearchControl isVerticalFullscreen={isVerticalFullscreen} currentMode={currentMode} />
            </div>
            <div className={clsx(styles['category-type-search__content'], {
                    [styles['category-type-search__content__vertical']]: !isHorizontal,
            })}>{renderContent()}</div>
        </div>
    );
};

export default CategoryTypeSearch;
